<div style="position: fixed; top:0; z-index: 1000; left:0; height:100%; width:100%; background: #222c;">
</div>


<div class="sideBar-info">
  <!-- <ion-card> -->

  <div style="overflow-x: auto; height:calc(100vh - 150px)">
    <ion-icon color='danger' name="close-circle" style="position: fixed; right:20px; top:10px; z-index: 99;"
      class='font2 floatingCloseAttachment cursorpoint' (click)='closePopup.emit()'></ion-icon>
    <ion-card style="margin-top: 60px; padding: 10px;">
      <!-- 
    urls?: string[] | null;
    -->
      <app-a-select *ngIf="cs.myMemberShip.role=='Treasurer'" [label]="'Donor'" [(variable)]="acs.payment.donor_id"
        [objectList]="cs.memberList" [type]="'Object'" [display]="'profile_meta'" [display2]="'name'"
        [value]="'id'"></app-a-select>

      <app-a-select [label]="'Payment Mode'" [(variable)]="acs.payment.mode"
        [objectList]="['Cash', 'UPI', 'Bank Transfer','Cheque', 'Kind']"></app-a-select>
      <app-a-input *ngIf="acs.payment.mode!='Kind'" [type]="'number'" [(variable)]="acs.payment.amount" [label]="'Amount'"></app-a-input>
      <app-a-input *ngIf="acs.payment.mode!='Kind'" [(variable)]="acs.payment.transaction_ref_no" [label]="'Transaction Ref No'"></app-a-input>
      <app-a-input [(variable)]="acs.payment.remarks" [label]="'Remarks'"></app-a-input>
      <app-date [(model)]="acs.payment.payment_date" [label]="'Payment Date'"></app-date>

      <app-a-select *ngIf="cs.myMemberShip.role=='Treasurer'" [label]="'Status'" [(variable)]="acs.payment.status"
        [objectList]="['Committed', 'Received', 'Denied']"></app-a-select>

      <ion-button (click)="savePayment()" expand="block" color="secondary">
        Save
      </ion-button>
    </ion-card>
  </div>

</div>